export default __webpack_public_path__ + "static/media/header.389cddda.png";